const ContainerData = () => {
  return [
    {
      name: '/shop/play',
      paragraph: [
        {
          title: 'Kids Toys: Playful, Stylish, and Made to Last',
          content:
            "Toys play a vital role in kids' development. As an online marketplace, Maisonette searches high and low for the best stuff for families, including our favorite toys for girls and boys. From family-owned toymakers to high-tech science-backed brands, our toys are categorized according to age, so you find the perfect match for your child's developmental stage, from infants to teenagers. Because what you consume for your kids matters."
        },
        {
          title: 'Toys for Every Age',
          content:
            'For young children, [0] like the beloved [1] can stimulate their imagination and develop emotional intelligence early. Toddlers love play kitchens that allow kids to explore their culinary creativity while learning about food, nutrition, and life skills. Preschoolers gravitate to cars and trains, art supplies, and outdoor toys like ride-on cars and balance bikes. [2] encourage imaginative play and role-play. Dressing up fosters creativity and social skills as they interact with others in their make-believe world.',
          canonicalUrls: [
            { name: 'baby toys', url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/baby` },
            { name: 'baby doll', url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/kids/dolls-doll-accessories` },
            {
              name: 'Kids costumes',
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/kids?product_type=Costumes`
            }
          ]
        },
        {
          title: 'Educational Toys',
          content:
            "When it comes to [0], we have you covered. Maisonette curates toys for girls and boys that promote cognitive development, problem-solving, and critical thinking. For example, building blocks, puzzles, or STEM-based kits provide hands-on learning experiences that enhance children's cognitive abilities and spark their curiosity.",
          canonicalUrls: [
            { name: 'educational toys', url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/learning/stem-toys` }
          ]
        },
        {
          title: '',
          content:
            'Whether she loves puzzles, riding bikes or silly games, toys for girls will inspire her to try new challenges, use her imagination. What about toys for boys? By choosing kids toys that entertain, educate, and inspire, you can provide boys and girls with hours of joyful play while supporting their overall development.'
        }
      ]
    },
    {
      name: '/shop/baby/girl-clothing/swim',
      paragraph: [
        {
          title: 'Baby Girl Swimsuits',
          content:
            "Make a splash this summer with our adorable baby girl swimsuits and swimwear collection. Whether heading to the beach or the pool, our baby swimwear will keep your baby girl stylish and protected, whether you're looking for sun-kissed colors, bright tropical prints, sweet ruffles, or nautical stripes and classic gingham."
        },
        {
          title: 'Mix and Match Style Options',
          content: `Our baby swimwear collection comes in different styles and sizes to suit your baby's needs: two-piece sets and separates in soft and stretchy materials allow you to mix and match easily, while one-pieces with long sleeves cover their arms and keep them protected. Swim diapers are a convenient option for hassle-free diaper changes. Pair diaper covers and bloomers with a [0] or bathing suit top.`,
          canonicalUrls: [
            {
              name: 'rash guard',
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing?product_type=Rash%20Guards`
            }
          ]
        },
        {
          title: 'Made in The Shade',
          content:
            '[0] is essential, and baby swimwear from brands like Flap Happy and Bonbon Swim offers sun protection to keep your little one safe from harmful UV rays. And when you need to take a break from the water, our cozy coverups, [1], hats, sunglasses, and [2] provide extra shade and protection.',
          canonicalUrls: [
            { name: 'Sun protection', url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/swim-sun-shop` },
            { name: 'summer shoes', url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/summer-shoes` },
            { name: 'baby girl dresses', url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing/dresses` }
          ]
        },
        {
          title: '',
          content:
            "Get your little fish excited for sunny days by the sea with our baby girls' swimwear in polished prints, purposeful details, and hard-working fabrics."
        }
      ]
    },
    {
      name: '/shop/womens',
      paragraph: [
        {
          title: 'Women’s Clothing',
          content:
            "Maisonette is more than just [0]. We're all about stylish clothes for women that feel good, look great, and make you feel confident from school drop-off to work to date-night-out. From the moment you're ready for [1] and beyond, our [2] in mini, midi, and maxi lengths to of-the-moment trousers, and no-brainer matching sets, make you feel your most confident and most beautiful – even if tbh half the time you're packing lunch and pretending to be [3] on the floor.",
          canonicalUrls: [
            {
              name: 'kids clothes',
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids`
            },
            { name: 'maternity clothes', url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/womens/maternity` },
            { name: 'easy dresses', url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/womens/maternity/dresses` },
            { name: 'mermaids', url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/mermaids` }
          ]
        },
        {
          title: 'What to Wear',
          content: `While you're shopping for your mini, refresh your wardrobe with womens clothing to add a cool-mom vibe to everyday looks. Whether you're looking for a chic top for parent-teacher conferences, cozy pajamas from Petite Plume for sleeping in, activewear from Split59, or even swimsuits from brands like Hermosa and Citrine Swim for your next beach vacay, Maisonette is your one-stop shop.`
        },
        {
          title: 'Elevated Essentials & Accessories',
          content:
            'Build your capsule wardrobe around staples like underwear, bras, tops, tunics, t-shirts, shirts, sweatshirts, and leggings. Add outerwear and layers like a chic ready-for-any-weather cardigan or jacket to stay warm and comfy through the seasons. Pair with [0] like a fantastic jewelry selection, shoes, and hats from brands like Eugenia Kim, Lorna Murray, Brinker & Eliza, Tiny Tags, Loren Stewart, Casa Clara, Bensimon, Camper, and Le Monde Beryl. Beyond clothes for women, check out our [1] shop for matching moments.',
          canonicalUrls: [
            {
              name: 'accessories for women',
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/womens/shoes-accessories`
            },
            { name: 'mommy and me', url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/whats-new/shops/mommy-me-shop` }
          ]
        }
      ]
    },
    {
      name: '/shop/kids/boy-clothing/swim',
      paragraph: [
        {
          title: 'Boys’ Swimsuits and Swimwear',
          content:
            'Make a splash this summer with our charming boys’ swim trunks and swimwear collection. Whether heading to the beach or the pool, our swimsuits will keep him safe and protected, as he explores the world.'
        },
        {
          title: 'Mix and Match',
          content:
            'Our swimwear collection comes in different styles and sizes: crisp board shorts and [0] in soft and stretchy materials allow you to mix and match easily. Long sleeves cover their arms and keep them protected.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing?product_type=Rash%20Guards`,
              name: 'rash guards'
            }
          ]
        },
        {
          title: 'Made in The Shade',
          content:
            '[0] is essential, and boys swimwear from brands like Minnow, Pearl Swim, and Flap Happy offers sun protection to keep your little one safe from harmful UV rays. And when you need to take a break from the water, our cozy coverups, [1], [2], and [3] provide extra shade and protection.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/swim-sun-shop`,
              name: 'Sun protection'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/summer-shoes`,
              name: 'summer shoes'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-accessories/hats-scarves-gloves`,
              name: 'hats'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-accessories/sunglasses`,
              name: 'sunglasses'
            }
          ]
        },
        {
          content:
            "Get your little fish excited for sunny days by the sea with our boys' swimwear in polished prints, purposeful details, and hard-working fabrics. Whether you're looking for sun-kissed colors, bright tropical prints, nautical stripes and classic gingham, our collection is your one-stop shop. Ready to pack it all in the car and go? Don’t forget [0], and beach towels.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/outdoor/water-play`,
              name: 'water toys'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/play/kids/dollhouses-accessories',
      paragraph: [
        {
          title: 'Dollhouses and Accessories',
          content:
            "Nurture kids' imaginative play with dollhouses and furniture to fit their growing doll family. Brands like Barbie, Milton & Goose, KidKraft, and Le Toy Van design dollhouse accessories with attention to every teeny doll-sized detail. Think: grand staircases, pools, a slide, garages, patios. Enhance the play experience by adding furniture or [0] that are just their size. These dollhouses and accessories make birthday-worthy gifts or holiday treats –– they’re the classic [1] that spark joy and foster creativity and storytelling.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/kids/dolls-doll-accessories`,
              name: 'dolls'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/kids`,
              name: 'kids toy'
            }
          ]
        },
        {
          title: 'A Dollhouse For Every Style',
          content:
            "Maisonette's collection of dollhouses caters to your child's style, ranging from enchanting castles and cozy chalets to charming wooden cottages and modern A-frames. The options include farmhouses, outhouses, and even a shepherd's hut. Your minis will be delighted to discover beds, tables, chairs, cooking utensils, pools, elevators, and even a pink convertible to park in the garage, offering unlimited possibilities for [0] adventures.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/kids/pretend-play-play-tents-vanities`,
              name: 'pretend play'
            }
          ]
        },
        {
          content:
            "The appeal of dollhouses is so irresistible that you find yourself on the playroom floor redecorating. Playing with dollhouses can inspire kids to take on small household chores (don't hold your breath), encouraging responsibility and independence.",
          canonicalUrls: []
        }
      ]
    },
    {
      name: '/shop/play/baby/activity-gyms-playmats',
      paragraph: [
        {
          title: 'Baby Playmats and Activity Gyms',
          content:
            'Looking for a baby playmat and play gym for your little one? Discover a wide collection of fun baby activity gyms that create a cozy play space for tummy time. Many experts recommend babies start tummy time in their first weeks of life. Baby play mats give them a soft place to hang while they begin the hard work of growing, strengthening their muscles, and learning about the world. Baby play mats run the gamut from interactive mats with pulls and to a soft, simple place to lay their heads.'
        },
        {
          title: 'Types of Play Gyms',
          content:
            'There is a play mat or gym for every age or stage of development. Choose from soft baby playmats in adorable shapes like lily pads and pears, plush play mats shaped like unicorns and dragons, or blankets with captivating black-and-white graphics. Enhance the play experience with infant toys like rattles, teethers, or activity cubes. Wood play gyms are ideal for babies learning to stretch, reach, and pull from the hanging bar. For toddlers, Montessori wooden balance beams and little climbers with a rock wall offer more mobility and exploration.'
        },
        {
          title: 'How to Use a Baby Play Gym',
          content:
            "Make the most of your baby's gym by incorporating activities that stimulate their growing brains and muscles based on their age. Dress them in plain, soft [0], lay them on the mat and observe as your baby stretches, rolls, reaches, smiles, and giggles, marking their progress and growth along the way.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby`,
              name: 'baby clothes'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/play/kids?product_type=Costumes',
      paragraph: [
        {
          title: 'Imaginative Kids Costumes and Dress Up Clothes',
          content:
            "Maisonette's collection of kids costumes is for the mini roaring like a lion, saving the day like a superhero, and being a boss like the queen they are. Why not look the part? We've curated the best selection of kids dress up clothes from brands like Meri Meri, Great Pretenders, Little Adventures, and Bailey & Ava."
        },
        {
          title: 'From Fairy Tales to Animal Costumes',
          content:
            "Whether it's a birthday gift, trick-or-treating on [0], or to stock the playroom for everyday imaginative [1], you'll find kids costumes that empower kids to create fantasy worlds with princesses, unicorns, fairies, dragons, mermaids, knights, and wizards. They can channel the animal kingdom with dress up clothes for lions, tigers, flamingos, ladybugs, and even a just-their-size octopus. They’ll save the day with superhero costumes like Wonder Woman, Superman, Batman along with everyday heroes like firefighters and doctors. Head back in time with dinosaurs or get inspired by classic stories with Little Red Riding Hood, Snow White, Belle, Cinderella, and Tinkerbell or surprise them with kid-favorite character costumes from shows like Paw Patrol and Sonic.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/the-halloween-shop`,
              name: 'Halloween'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/kids/pretend-play-play-tents-vanities`,
              name: 'pretend play'
            }
          ]
        },
        {
          title: 'Kids Dress up Accessories',
          content:
            "Remember to complete the look with dress up accessories like tiaras, wands, swords, wings, and masks. Meant to last, our kids' costumes are made with quality materials like tulle, sequins, velvet, and the softest faux fur that are less itchy and often OK to be thrown in the laundry."
        }
      ]
    },
    {
      name: '/shop/play/kids/play-kitchens',
      paragraph: [
        {
          title: 'Play Kitchens for Kids and Toddlers',
          content:
            "The play kitchen is an MVP [0] in many playrooms, and it's easy to see why. Kids from 2 to 6 (and beyond) love to mimic their grownups to make breakfast for mom, set up a pop restaurant, or craft a culinary masterpiece. Plus, play kitchens are timeless and excellent for open-ended play, building confidence and communication – even pre-coding skills. And they're just fun.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play`,
              name: 'toy'
            }
          ]
        },
        {
          title: 'A Play Kitchen Style For Every Kid',
          content:
            "From cottage chic to a mini version of your kitchen and even a few small-space-friendly options, Maisonette has the best toy kitchen selection for kids and toddlers. You're sure to find something your littlest chef will love."
        },
        {
          content:
            'Brands like Teamson Kids, Tender Leaf Toys, Kidkraft, and Milton & Goose create play kitchens that stand the test of time in styles that suit any playroom. There are minimalist wood and hand-braided soft and squishy play kitchens and ones with all the bells and whistles like ice machines, pizza ovens, knife blocks, drawers and ovens that open – even dinging timers. For those with limited space, try a tabletop toy kitchenette.'
        },
        {
          title: 'Play Food & Kitchen Accessories',
          content:
            'Play kitchens make a statement as that hero birthday gift or under the Christmas tree surprise. Pair your gift with [0] to use in their pretend play – felt eggs, wood veggies to practice cutting, and plastic pizzas, strawberries, and the most important toddler food category, ketchup.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/kids/play-food-accessories`,
              name: 'play food'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/kids/girl-clothing/tops',
      paragraph: [
        {
          title: 'Girls Tops All In One Place',
          content:
            "Looking for stylish girls' shirts? Update her everyday essentials with Maisonette's edit of girls' shirts and tops. Pair them with our [0] and [1] to complete your look. Girls' shirts are the perfect place to let your child's personality shine in what she wears, whether she prefers a casual and comfortable look or something more dressed up.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/girl-clothing/pants`,
              name: "girls' pants"
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/girl-accessories`,
              name: 'cute accessories and shoes'
            }
          ]
        },
        {
          title: 'Girls Shirts for All Seasons',
          content:
            "Find this season's coolest tops for girls at Maisonette, from fun embellishments and cute graphics to matching short sets, cozy sweatshirts, and nautical sweaters. Our carefully curated collection features a variety of brands, including Lola & The Boys, Tea Collection, Little English, and Primary. We understand that every girl has her unique personality, so we offer a range of styles to suit her individual taste. Basic tank tops and cool graphic t-shirts will see her through the week, while elevated blouses and ruffled tank tops are just-right for a [0] for the weekend. Our go-to tees are always in style, and she'll love the pretty ruffled, tie-dyed, and embroidered details, fun messages, or illustrations. Layering tees in various colors are also available for those cooler days when a [1] or sweatshirt is needed.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/girl-clothing`,
              name: 'girls outfit'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/girl-clothing/sweaters`,
              name: 'girls sweater'
            }
          ]
        },
        {
          content:
            "With a wide range of colors, prints, and patterns, she's sure to find a shirt she loves at Maisonette. We have it all, whether she's into bright summer colors, soft pastels, adorable florals, or holiday prints. Explore our collection today and update her wardrobe with the cutest girls' tops."
        }
      ]
    },
    {
      name: '/shop/kids/girl-clothing/dresses',
      paragraph: [
        {
          title: 'Girls’ Dresses All In One Place',
          content:
            "Looking for the perfect girls' dress? When it comes to easy one-and-done outfits Maisonette’s collection of dresses for girls offers a wide range of styles and options to suit every occasion and your little mini’s vibe. Whether she loves floral Liberty prints, gingham, classic stripes, or bold graphics, we have prints and patterns that will make her shine."
        },
        {
          content:
            'Our girls\' dresses are designed with comfort and style in mind. We offer dresses made from natural fabrics like organic cotton, linen, and velvet ensuring that your child feels comfortable and cool throughout the year. With a variety of hues to choose from, you can find the perfect dress for any season. [0] are also available for those special occasions. Adorned with [1], tutu-inspired skirts, or lace , they are sure to make her feel like a princess. Maisonette editors even curate the [2] so you can stock up on those "throw on and go" looks.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop?occasion=Party`,
              name: 'Party dresses'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop?occasion=Sequin+%26+Shine`,
              name: 'sequins'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop?occasion=Dresses%20Under%20%2450`,
              name: 'best girls dresses under $50'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/back-to-school-apparel`,
              name: 'back-to-school outfits'
            }
          ]
        },
        {
          content:
            "Whether you're shopping for [0], everyday wear, holidays with family, or a special occasion, our girls' dresses are versatile and easy to style. That's why we offer a wide assortment of brands, from Hill House Home to Angel Dear, Sunday Collective, and Lola & The Boys. Complete with our adorable hair accessories for girls and a pair of canvas sneakers or mary janes to create an outfit they’ll love..",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/back-to-school-apparel`,
              name: 'back-to-school outfits'
            }
          ]
        },
        {
          content:
            'You’ll find a diverse range of styles, from understated smocked styles to pinafores, ruffles and wrap styles. For warmer days, our cute sundresses keep her cool and fashionable. When the weather turns colder, long sleeve dresses provide warmth and keep her cozy.'
        }
      ]
    },
    {
      name: '/shop/kids',
      paragraph: [
        {
          title: 'Kids Clothes for Every Mini',
          content:
            "Looking for the best kids' clothes for school, play, and parties –– [0] for cozy nights. Maisonette has everyday essentials and exclusive styles for toddlers and big kids as they grow. Our kids' clothing is made for adventures. Mini will be ready for anything with organic cotton t-shirts and poplin blouses to smocked dresses, shorts, and pants. You'll find brands like Stella McCartney, Pink Chicken, Lola & the Boys, and Little English.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing/sleepwear`,
              name: 'even pajamas'
            }
          ]
        },
        {
          title: 'Toddler Outfits',
          content:
            "Welcome to toddlerhood. Dress the littlest minis in our editor’s picks – filter by age, occasion, gender, and brand to find childrens clothes they will love wearing. After they graduate from baby onesies, rompers, overalls, ruffled skirts, and blouses with Peter Pan collars are perfect for toddlers' little bodies. For rough and tumble play and those early potty training days, joggers, leggings, and chinos are easy on and off, while [0] and leggings grow with them.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop?product_type=Dresses`,
              name: 'stretchy dresses'
            }
          ]
        },
        {
          title: 'Boys and Girls Clothing',
          content:
            "Stock up on easy and elevated kids’ clothing that can be passed along to siblings and friends. Keep warm with sweatshirts, sweaters and kids' jackets. Stay cool in the warm summer months with sandals. For [0], we’ve curated sweet patterned dresses you won't find anywhere else, sporty shorts and the extra layers to help make her cozy all day. For guys, [1] chinos, button downs, swim, and graphic tees. Of course, kids have their own sense of style, so mix and match every style of children’s clothes for every kid. At night, tuck them into pajamas in the softest stretchy knits and brushed twill from brands like Petite Plume, Benben, and Joy Street Kids.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/girl-clothing`,
              name: "girls' clothes"
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing`,
              name: 'boys clothes'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/kids/girl-accessories/shoes',
      paragraph: [
        {
          title: "Girl's Shoes, Boots and Sneakers",
          content:
            "Looking for girls' shoes? Discover Maisonette's collection of stylish girls' boots, sneakers, and sandals, perfect for heading to the park, school, or parties. These shoes for girls will be there every step of the way. As she explores the world, she'll feel confident in comfortable girls' sneakers from brands like Cienta and Bensimon, sunny day leather sandals from L'Amour, and throwback jelly shoes in a rainbow of shades from Mini Melissa. In the fall and winter, we have classic mary janes, classic lace-up boots, cool cowgirl boots, and loafers from brands like Age of Innocence and Childresnchic ready to [0].",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/back-to-school`,
              name: 'return to school'
            }
          ]
        },
        {
          content:
            "Our collection also includes dress shoes for special occasions, ensuring she looks her best when it's time to dress up. We have sweet little [0] for spring holidays and the perfect [1] for parties and weddings. Maisonette has seasonal footwear like girls' boots, water shoes, and rain boots, ensuring her feet stay cozy and dry no matter the weather.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/girl-accessories/shoes?color=White`,
              name: "girls' white shoes"
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/girl-accessories/shoes?color=Gold`,
              name: "girls' gold shoes"
            }
          ]
        },
        {
          content:
            'From her very first steps to the first days of school, first snow days, and first summer vacations, our selection of shoes are carefully curated and designed to support her journey from toddler to big kid. When shopping for features like rubber soles, supportive footbeds, and soft linings, her feet will stay protected and cozy all day long. Complete her outfit with [0] like bows, jewelry, and backpacks throughout the year.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/girl-accessories`,
              name: "girls' accessories"
            }
          ]
        }
      ]
    },
    {
      name: '/shop/kids/girl-accessories/hair-accessories',
      paragraph: [
        {
          title: 'Girls’ Hair Accessories - Headbands, Hair Clips and Hair Ties',
          content:
            "Add the finishing touch to her outfit with Maisonette’s hair accessories for girls. We have patterned headbands as well as pretty hair clips, multi-colored hair ties, barrettes and more to keep her hair away from her face or to dress up for special occasions. Part function, all style, our girls' hair accessories feature the looks and colors that all the kids want. Think: cool plaids, polka dots, Liberty prints, and classic stripes along with colorful acrylic. Add quirky whimsy hair clips to her outfit, like barrettes that include characters and icons such as mermaids, suns, rainbows, shells, berries, flowers, and ice cream cones."
        },
        {
          content:
            'Our favorites are kids hair accessory sets from brands like Annie Lane and Wunderkind Co. for everyday, or bows with fabrics that match [0] from brands like Lali, Folklore Las Niñas, and Bebe Organic. For birthday parties, weddings, or holidays try headbands covered in sparkles and rhinestones or oversize bows, even a tiara.',
          canonicalUrls: [
            {
              name: 'girls’ clothes',
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing`
            }
          ]
        },
        {
          content:
            'Good-to-go on girls’ hair accessories? Shop the collection or check out our [0] like jewelry, tights, and hats for more inspiration. For the littlest mini, explore our selection of [1].',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/girl-accessories`,
              name: 'girls’ accessories'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-accessories/bows`,
              name: 'baby girls’ hair accessories'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/kids/boy-clothing/shorts',
      paragraph: [
        {
          title: 'Boys’ Shorts',
          content:
            "Explore our selection of boys' shorts ready for every day and weekend play. Whether you’re looking for a pair of elastic shorts to complete an outfit, or shorts sets that are one-and-done, Maisonette curates the best selection of shorts for boys at a range of prices. They’re the item of boys clothing that feels most like summer has finally arrived."
        },
        {
          content:
            'Our curated collection of boys’ shorts bring a vibe for every occasion and age. For beach days or a week at camp, we love casual chambray shorts, track shorts, joggers, or bike shorts. Toddlers and preschoolers will have an easier time with slightly oversized or stretchy shorts that have a drawstring or elastic waistband, especially as boys are learning to go to the potty or how to get dressed independently. Grade school boys will love our uniform-ready shorts in structured khaki and navy. For more put-together summer looks, try seersucker or chinos. Beyond summer solids, we carry stripes, checkerboard, color blocking, nautical prints, and tie-dye. A few of our go-tos: terry cloth track shorts with a retro white trim, bike shorts in bright colors, and breezy camp shorts. Because comfort is king, no matter the occasion or the activity, we’ve prioritized boys’ shorts that are ultra cozy, yet provide a put-together look. Depending on his needs, look for features like Dri Fit fabrics, organic cotton and OEKO-TEX fabrics, matching shirt & short sets with matching [0]. Complete his outfit with [1] that he can wear anywhere.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing/tops`,
              name: 'boys shirts'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/summer-shoes`,
              name: 'summer shoes'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/kids/boy-clothing/pants',
      paragraph: [
        {
          title: 'Boys’ Pants',
          content:
            'Make every outfit a statement with boys’ pants from Maisonette. From cozy drawstring pants to pulled-together dress pants, he’ll stand out (in the best way). Choose from jeans, corduroy styles, chinos, and stretchy elastic waistbands that feel fresh and effortless while being comfortable enough to end up in his everyday rotation. Shop your favorite brands like Me & Henry, Tea Collection, Little English, Caramel, Primary, and the Simple Folk.',
          canonicalUrls: []
        },
        {
          title: 'Boy Sweatpants, Leggings and Joggers',
          content:
            'For hanging around the house, grab drawstring joggers in organic cotton or soft fleece - with a slouch fit he’ll pick up again and again. For boys’ sweatpants or [0] (that you feel comfortable with him wearing in public), go for a more tailored pair that can transition from school to practice. Prints, track stripes, and tie-dye add to his personality and style.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing?product_type=Loungewear`,
              name: 'loungewear'
            }
          ]
        },
        {
          title: 'Boy’s Khakis and Chinos',
          content:
            'If you’re planning a special event or need a crisp look for a school uniform, religious services, or performance, khakis and chinos paired with a blazer over a polo or collared [0] are a perfect fit. For a more casual vibe, try nautical seersucker and breezy, airy linen for a stylish alternative for warm weather pants.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing/tops`,
              name: 'boys’ shirt'
            }
          ]
        },
        {
          title: 'Boys’ Athletic Pants',
          content:
            'Let’s face it, [0] takes a beating, and pants seem to be the trickiest to keep in good shape for active kids. Stock up on basics like athletic pants in pull-on styles made from lightweight, moisture-wicking fabrics and a relaxed fit. Pair them with graphic t-shirts, hoodies, and boys’ shoes for a relaxed, casual and complete outfit that moves with him.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing`,
              name: 'boys’ clothing'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/home/furniture/cribs-bassinets',
      paragraph: [
        {
          title: 'Baby Cribs',
          content:
            "A baby crib is one of the most important and exciting purchases you'll make for your baby. Before buying a crib or baby bassinet, consider the features, your available space, and the look you want for your nursery. There are several types of cribs to keep in mind based on your preferences and space: non-convertible, convertible cribs, and portable or travel cribs. Most standard cribs today are designed to fit a standard-size [0] and [1], can be height-adjusted, so you can keep the mattress higher when your baby is young, and lower it when they learn to stand up to prevent climbing accidents. A convertible crib is an option if you want your child to be able to continue to use the crib as they grow into the toddler years. It can convert into a toddler bed or a daybed using the same mattress. If you have a small space, you may want to consider a travel crib or mini crib. Smaller cribs and can be easily disassembled and packed up for travel. If you plan to go on trips or stay with relatives with your baby, it's a good idea to get a travel crib in addition to your regular baby crib. Maisonette curates a collection of styles, colors and finishes – from traditional to modern so it's easy to find a baby crib that matches the decor of your nursery.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/home/bedding-bath/mattresses-changing-pads`,
              name: 'crib mattress'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/home/bedding-bath?product_type=Crib%20Sheets`,
              name: 'crib sheets'
            }
          ]
        },
        {
          title: 'Baby Bassinets',
          content:
            "For the first four to six months you may prefer to have your baby in a bassinet in your bedroom as they're smaller – light, portable and convenient. Bassinets give you the flexibility to not make major arrangements. You may even decide to hold off on purchasing a crib or [0]. Maisonette curates several different styles from a Scandi-inspired box set with Oeko-Tek certified cotton sheet and mattress to baby bassinets with smart technology.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/home/furniture`,
              name: 'designing a nursery'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/kids/boy-clothing/sleepwear',
      paragraph: [
        {
          title: 'Boys’ Pajamas',
          content:
            "No matter what you call them in your house (PJ's, jammies, or even jam-jams) our super soft pajamas feel and fit like a dream.. Maisonette’s collection of boy’s pajamas comes in the softest fabrics,coolest prints and most-loved styles for every kind of kid. From classic styles in gingham or stripes to stretchy knits with modern graphics, finding a pair of boys’ pajamas that they love to wear can make bedtime just a little bit easier. For a fun take on family movie nights, holidays or just-because, shop [0] for holidays like Easter, Halloween, and Christmas.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/holiday-pajamas`,
              name: 'matching family pajamas'
            }
          ]
        },
        {
          content:
            'While most [0] are designed as one-pieces with easy functionality like zippers or snaps for easy late-night diaper changes, bigger kids typically graduate to two-piece pajama sets. They’re equally as cozy, but more versatile with fun prints including dinosaurs, astronauts, and any animal you can dream of. Tuck them in for a good night’s sleep with matching [1] and [2] as they climb into [3] at night.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/boy-clothing/sleepwear`,
              name: 'baby boy pajamas'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/home/bedding-bath`,
              name: 'bedding'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/home/bedding-bath/blankets-quilts`,
              name: 'blankets'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/home/furniture/beds`,
              name: 'bed'
            }
          ]
        },
        {
          content:
            "As for child's safety, garments should fit snugly. Comfortable, snug fit fabrics are essential for boys' pajamas and many you’ll find here are OEKO-TEX Standard 100 certified fabric, bamboo, and 100% Pima Cotton. Does your mini always seem to be growing out of their favorite pajamas? Opt for thin and stretchy materials to make that fit last a little bit longer. Check the style, as many boys’ pajamas can be monogrammed."
        }
      ]
    },
    {
      name: '/shop/kids/girl-clothing/sleepwear',
      paragraph: [
        {
          title: "Girls' Pajamas, Nightgowns and Pajama Sets",
          content:
            "Girls’ pajamas encourage sweet dreams with colorful prints, soft fabrics and fun themes for holidays or different times of the year. No matter what you call them in your house (PJs, jammies, or even jam-jams), our cozy pajamas feel and fit like a dream. Maisonette's collection of girls' pajamas comes in the softest fabrics in prints and styles for every girl. From classic nightgowns and two-piece pajama sets in brushed cotton or knits with modern graphics, the right girls' pajamas can make bedtime just a little bit easier. We even have matching family pajamas for Easter, Halloween, and Christmas holidays."
        },
        {
          content:
            "While most [0] are designed as one-pieces with easy functionality like zippers and snaps for easy late-night diaper changes, as girls grow, they typically graduate to two-piece girls' pajama sets in long sleeve or short-sleeve styles, depending on the weather. They're multi-purpose and are more versatile in fun prints, including florals, mermaids, rainbows, and any animal. She’ll be cozy when you tuck her into her [1] and under the [2] at night.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing/sleepwear`,
              name: 'baby girl pajamas'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/home/bedding-bath/sheets`,
              name: 'bed sheets'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/home/bedding-bath/blankets-quilts`,
              name: 'blankets'
            }
          ]
        },
        {
          content:
            "Your childs’ safety is essential. Garments should fit snugly and comfortable, snug-fit fabrics are essential when we add girls' pajamas to our collection. Many you'll find here are OEKO-TEX Standard 100 certified material, bamboo, and 100% Pima Cotton. Check the style, as many of our pajamas can be monogrammed."
        }
      ]
    },
    {
      name: '/shop/gear/diaper-bags-luggage',
      paragraph: [
        {
          title: "Diaper Bags & Kids' Luggage",
          content:
            "Kids bring joy. And so much stuff. A reliable and functional diaper bag and go-to family and kids’ luggage are essential [0] for new parents. But you don’t have to carry a bulky, old-school diaper bag. People may not even know you're rocking a bag outfitted with functionality like pockets and bottle holders. Explore the different types of diaper bags available, including diaper totes, diaper sling bags, diaper backpacks, and stroller handlebar diaper bags or fanny packs.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/gear`,
              name: 'baby gear'
            }
          ]
        },
        {
          title: 'Diaper Totes',
          content:
            'Diaper totes are a popular choice among stylish moms who want a bag that looks IRL office-ready while still providing ample storage space. These bags look like regular tote bags but often come with multiple compartments and pockets to organize [0], bottles, and other baby essentials. Diaper totes are versatile and can easily transition from a diaper bag to a regular handbag.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/gear/diapers-wipes`,
              name: 'diapers and wipes'
            }
          ]
        },
        {
          title: 'Diaper Backpacks',
          content:
            'New styles like diaper bag backpacks have gained popularity among parents who require a bag that offers maximum functionality and comfort. These bags distribute the weight evenly on both shoulders, reducing strain on the back and leaving your hands free. Diaper bag backpacks typically have a large main compartment, multiple pockets, and insulated bottle holders. They are perfect for parents who like to be well-prepared and organized while on-the-go.'
        },
        {
          content:
            "Another good on-the-go option are [0] handlebar diaper bags, which are designed to attach to the handlebar of your baby's stroller, providing easy access to all your essentials. They often feature multiple compartments and pockets to keep everything organized and within reach. If you think this might be a good option for you, consider these or the diaper bag backpack, as many styles offer clips that can be attached to the handlebar of your stroller.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/gear/strollers`,
              name: 'stroller'
            }
          ]
        },
        {
          content:
            'No matter which type of diaper bag or luggage you choose, functionality, comfort, and style are key considerations. Look for features like waterproof materials, easy-to-clean surfaces, adjustable straps, and insulated bottle holders. Consider your lifestyle and preferences to find the perfect diaper bag or luggage that meets your needs. You can confidently take on any outing with your mini with the right diaper bag and travel is easier with your favorite luggage.'
        }
      ]
    },
    {
      name: '/shop/baby/girl-clothing',
      paragraph: [
        {
          title: 'Baby Clothes for Girls',
          content:
            'With Maisonette’s collection of baby girl clothing you’ll be ready for anything. For baby basics, stock up on essentials like onesies, bodysuits, one-and-done [0] and bubbles that they’ll live in day to day. When they’re ready to play and roll over, try stretchy [1], coveralls. Choose from details like ruffles and smocking. Patterns like nautical ticking, stripes, ginghams, and toile prints feel classic while chambrays, muslin are a more utilitarian take. For a more casual take we love modern prints and graphics in an uplifting color palette.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing/rompers`,
              name: 'rompers'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing?product_type=Leggings`,
              name: 'leggings'
            }
          ]
        },
        {
          content:
            'For cooler months, layer on cardigans, puffer coats, and cozy hats. Complete the look with booties and pre-walking shoes, along with hair bows and bands as they get a little older. In summer, swim diapers and [0] along with [1] to keep the sun off their infant skin. If you’re heading to a special occasion, style her in timeless [2] - many with matching bloomers.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing/swim`,
              name: 'bathing suits'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing?product_type=Rash%20Guards`,
              name: 'rash guards'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing/dresses`,
              name: 'baby girl dresses'
            }
          ]
        },
        {
          title: 'Newborn Girls’ Clothes',
          content:
            'Ready to bring home a new babe or looking for the perfect gift? Embroidered onesies with their sweet new name are a thoughtful surprise along with luxe [0] sets they’ll wear again and again. Babies sleep throughout the day so finding the perfect snug fit [1] for naptime and bedtime - with 2-way zippers for late night changes or two piece sets for newborns with footies or without them that come in every color and print.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/gifts/by-age/gifts-for-newborns`,
              name: 'newborn gift'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing/sleepwear`,
              name: 'baby girl pajamas'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/baby/girl-clothing/rompers',
      paragraph: [
        {
          title: 'Baby Girl Rompers',
          content:
            'Is there anything cuter than a baby romper? These early-day essentials are one-and-done [0] that work from playground-perfect overalls to beach-ready sunsuits or ruffled bubbles. All you need to add is a sweet set of [1] for their tiny feet. Available in soft fabrics like breathable organic cotton muslins, super soft thermal knits, chambray, and terry options, they make life with an infant easier. Our baby girl jumpsuits and footies feature long sleeves to keep her warm in the cooler winter months, while our baby rompers, sunsuits, and bubbles are perfect for playing throughout the summer.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing`,
              name: 'outfits'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-accessories/tights-socks`,
              name: 'socks'
            }
          ]
        },
        {
          content:
            'Looking for a romper for girls in a playful print or pattern? From classic ginghams to nautical stripes, quirky animal prints to florals, and modern graphics, there is a style for every baby. Features like smocking, ruffles, piping, and embroidery add interest for parties and special occasions.'
        },
        {
          content:
            'While all of these styles are one-pieces, baby girl rompers have short or long legs and even footies, while bodysuit rompers or sunsuits just cover their bum – diapers and all. For overalls and other sleeveless styles, you may want to add a [0] to layer underneath. They all typically have easy on-and-off closures like snaps and zippers for convenient diaper changes. A practical choice for busy families, baby girl rompers provide both style and functionality.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing/tops`,
              name: 'baby top'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/baby/boy-clothing',
      paragraph: [
        {
          title: 'Baby Boy Clothes',
          content:
            "What's not to love about showing off your babe with cozy newborn baby boy clothes? Bring him home in a photo-ready soft knit layette. Stock up on basics to be ready for the many daily changes (spit-up and blowouts are too real) with the essential onesies, leggings, and footies."
        },
        {
          title: 'Infant Pajamas and Newborn Essentials',
          content:
            'Give him sweet dreams with our snug-fit [0] and loungewear in sweet patterns from brands like Petite Plume and Angel Dear. Maisonette carries so many options for nap time: easy 2-way zippers, two pieces, and even newborn gowns.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/boy-clothing/sleepwear`,
              name: 'baby boy pajamas'
            }
          ]
        },
        {
          title: 'Infant Boy Clothes Ready for Anything',
          content:
            'Add an extra layer on cool days and nights with a [0] or sweater for a trip to the park. For more formal occasions, get your baby boy ready for his first family photo shoot or special event with a peter pan collar and sweet [1]. Keep tiny toes and heads warm with cozy socks and baby hats. Keep him safe in the summer with UV protection in baby boy [2].',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/boy-clothing/outerwear`,
              name: 'baby jacket'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/boy-clothing/rompers`,
              name: 'romper'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/boy-clothing/swim`,
              name: 'swimwear'
            }
          ]
        },
        {
          content:
            'Maisonette has all the newborn baby clothes you need to dress your babe in style, from preemies to bubbly infants.'
        }
      ]
    },
    {
      name: '/shop/baby/boy-clothing/pants',
      paragraph: [
        {
          title: 'Baby Boy Pants',
          content:
            'Looking for new baby boy pants for your mini? From cotton drawstring pants to pulled-together dress pants or overalls, he’ll stand out (in the best way) in Maisonette’s collection of pants for baby boys.'
        },
        {
          content:
            'We’ve got [0] with and without footies for infants and stretchy elastic styles that feel fresh and effortless so they end up in your everyday rotation. Pull them over a onesie or bodysuit paired with [1] and he’s ready for the day. Shop your favorite brands for baby boys in one place – Maisonette carries brands like Colored Organics, Pehr, Goimi, Minibrook, Bebe Organic, and Les Gamins.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/boy-clothing?product_type=Leggings`,
              name: 'leggings'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/boy-accessories/shoes-booties`,
              name: 'baby booties'
            }
          ]
        },
        {
          title: 'Joggers and Leggings',
          content:
            'For hanging around the house, which let’s face it, is what babies do best, he’ll stay cozy in joggers made from organic cotton or super warm fleece - with a slouchy fit you’ll pick up again and again.'
        },
        {
          title: 'Khakis and Chinos',
          content:
            'If you’re planning a special event or need a crisp look religious services pair a sweet cardigan over the perfect [0] for the moment like a polo or peter pan collared shirt with a dressed-up version of boys’ pants in a chino or twill fabric. Nautical seersucker and breezy, airy linen are a stylish alternative for warm weather pants.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/boy-clothing/tops`,
              name: 'baby shirt'
            }
          ]
        },
        {
          title: 'Athletic and Casual Pants',
          content:
            'Out of all the types of [0], pants seem to be the trickiest as they grow so fast. Stock up on basics to grow with them like athletic pants in pull-on styles in a relaxed fit.',
          canonicalUrls: [
            {
              name: 'baby boys’ clothing',
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/boy-clothin`
            }
          ]
        }
      ]
    },
    {
      name: '/shop/baby/boy-clothing/rompers',
      paragraph: [
        {
          title: 'Baby Boy Rompers',
          content:
            'Is there anything cuter than a baby boys’ romper? These early-day essentials are one-and-done [0] that work from playground-perfect overalls to beach-ready sunsuits or zip up footies. All you need to add is a sweet set of [1] for their tiny feet. Available in soft fabrics like breathable organic cotton muslin and jersey along with utilitarian chambray and super soft thermal knits options, they make life with an infant easier. Our baby boy jumpsuits and footies feature long sleeves to keep him warm in the cooler winter months, while our baby boy rompers, sunsuits, and bubbles are perfect for summer adventures to the park or the zoo.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/boy-clothing`,
              name: 'outfits'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/boy-accessories/shoes-booties`,
              name: 'socks'
            }
          ]
        },
        {
          content:
            'Looking for a romper for boys in a playful print or pattern? From classic ginghams to nautical stripes, dinos, farm animals, bugs and modern graphics, there is a style for every baby. You’ll find options from the best brands for babies like Angel Dear, Pehr, and Little English.',
          canonicalUrls: []
        },
        {
          content:
            'While all of these styles are one-pieces, baby boy rompers have short or long legs and even footies, while bodysuit rompers or sunsuits just cover their bum – diapers and all. For overalls and other sleeveless styles, you may want to add a [0] to layer underneath. They all typically have easy on-and-off closures like snaps and zippers for convenient diaper changes. A practical choice for busy families, baby boy rompers provide both style and functionality.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing/tops`,
              name: 'baby top'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/kids/boy-clothing/tops',
      paragraph: [
        {
          title: 'Boys’ Tops',
          content:
            "Looking for boys’ shirts he’ll actually wear, that you love too? Update his everyday essentials with Maisonette's edit of boys' shirts, tops, and sweaters. Pair them with our [0] and [1] to complete his look. Shirts are the perfect place to let your child's personality shine, whether he prefers super soft t-shirts, button downs or hoodies.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing/pants`,
              name: "boys' pants"
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-accessories/shoes`,
              name: 'shoes'
            }
          ]
        },
        {
          content:
            "Find this season's coolest boys tops at Maisonette, from graphics tees to matching short sets, cozy sweatshirts, and nautical sweaters. Our carefully curated collection features a variety of brands, including Animals Observatory, Me & Henry, Little English, and Primary. We understand that every kid has his unique personality, so we offer a range of options to suit his style. Basic tees and polo shirts will see him through the week, while cheeky printed button downs are just right for the weekend. Our go-to boys’ tops are always in style, and he'll love the details, fun messages, and illustrations. Long sleeve shirts in a rainbow of colors are also available for those cooler days when he’ll need a [0] or sweatshirt.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing/sweaters`,
              name: 'sweater'
            }
          ]
        },
        {
          content:
            "With a wide range of colors, prints, and patterns, he's sure to find a shirt he loves at Maisonette. We have it all, whether he's into bright summer colors, rich tropical hues, or holiday prints. Explore our collection today and update his wardrobe with hardworking boys shirts.",
          canonicalUrls: []
        }
      ]
    },
    {
      name: '/shop/baby',
      paragraph: [
        {
          title: 'Discover Baby Clothes and Essentials',
          content:
            'Shopping for soft and sweet baby clothes is one of the most exciting ways to get ready to meet your new babe. At Maisonette, we search high and low for the best stuff for families, including our favorite newborn clothes from brands like Pink Chicken, Petite Plume, Pehr, and Kyte Baby. Discover newborn essentials to keep them cozy all year, from organic onesies to pajamas you can zip up in the middle of the night and seasonal staples like sweaters to the sweetest [0].',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing/swim`,
              name: 'baby swimsuits'
            }
          ]
        },
        {
          title: 'Baby Girl Clothes',
          content:
            'Explore our collection of [0] and discover the many ways to keep your mini stylish and comfortable. The possibilities for cute outfits are endless: charming [1], monogrammed tops, [2], and baby dresses in pretty prints. Pair them with headbands and baby girl bows.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing`,
              name: 'baby girl clothes'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing/rompers`,
              name: 'rompers and onesies'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-accessories/bloomers`,
              name: 'bloomers'
            }
          ]
        },
        {
          title: 'Baby Boy Clothing',
          content:
            'Our [0] include essential layettes for bringing home your new babe to mix-and-match separates: onesies and rompers, joggers, graphic tees, and jackets for your newborn.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/boy-clothing`,
              name: 'baby boy clothes'
            }
          ]
        },
        {
          title: 'Unisex Baby Clothes',
          content:
            'Whether you’re waiting to find out or want a minimalist gender-neutral palette, Maisonette carries unisex baby clothes in soft fabrics and solid colors from brands like Primary, Goumi, and Colored Organics.',
          canonicalUrls: []
        },
        {
          title: 'Buying Tips for Newborns',
          content:
            "We source baby clothes for newborns to sizes 0-3 and 6-12 that make parents' lives easier. Shop your way, either by gender, clothing type, accessories and more. Here's what you need to get started: bodysuits in short and long sleeves, [0], knit hats, pants, socks that stay on, outwear for winter babies, and swim for summer babies.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/boy-clothing/sleepwear`,
              name: 'footie pajamas'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/gifts/by-age/gifts-for-newborns',
      paragraph: [
        {
          title: 'Baby Gifts',
          content:
            'Finding the perfect baby gift for a newborn. Maisonette makes gift giving even more exciting with luxe cashmere and knit gift sets, layettes for the very first days, keepsake baby boxes and classic baby books. Our editors have curated the very [0] with ideas, products, and [1] to choose to make it easy to find something parents-to-be will love, especially if you’re heading to a [2] in their honor.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/baby-registry`,
              name: 'best baby registry collection'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/baby-registry-must-haves`,
              name: 'best registry must-haves'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/baby-shower-gifts`,
              name: 'baby shower'
            }
          ]
        },
        {
          content:
            'When you’re choosing a baby gift there are two schools of thought - follow the registry or stick to elevated basics families will use day in and day out. For the latter, we love that our baby basics are both functional, versatile and beautiful – and many times also on the registry wish-list. Even better, our [0] is non-toxic and often GOTS or OEKO-TEX certified for baby’s ultra sensitive skin. You’ll find onesies, bodysuits, and leggings in sunny, unisex shades along with go-to essentials you can never have too many of, like burp cloths, [1], and [2].',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby`,
              name: 'baby clothing'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/gear/swaddles`,
              name: 'swaddles'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/baby/teethers-rattles`,
              name: 'rattles'
            }
          ]
        },
        {
          content:
            'Then, there are the baby gifts that feel personal, those special pieces worth going off-registry for like a[0] in honor of a beloved pet or onesie embroidered with their new name. Milestone pennants, [1] like sweater sets, and silver cups are momentos they’ll keep and pass along.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/kids/plush`,
              name: 'plush toy'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/registry-investment-pieces`,
              name: 'heirloom gifts'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/play/kids/dolls-doll-accessories',
      paragraph: [
        {
          title: 'Baby Dolls',
          content:
            'Baby dolls are a cherished childhood toy that offer comfort, creativity and endless hours of imaginative play. Maisonette curates an assortment of doll toys for toddlers and kids to fit their developmental stage and personality. You’ll find baby dolls in a range of materials, skin tones, and hair textures.',
          canonicalUrls: []
        },
        {
          content:
            'Besides being undeniably cute, Dolls are [0] that give them an opportunity to practice and develop empathy and social skills and make [1] come to life. We carry Barbie® and her friends along with lifelike baby dolls from Adora and Miniland to mission-driven doll brands like Origin Bees and Beautiful Curly Me. Some of our baby dolls have hidden talents - they can go into the bath or pool, which help kids with the transition into water and even encourage them to drink water and use the potty. We love soft fabric dolls for toddlers from Manhattan Toys, Tikiri Toys and Olli Ella.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/kids`,
              name: "kids' toys"
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/kids/pretend-play-play-tents-vanities`,
              name: 'pretend play'
            }
          ]
        },
        {
          content:
            'Along with realistic dolls, kids love to play with dolls shaped like animals and fairytale creatures: bunnies, [0], ballerinas, princesses, and unicorns.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/mermaids`,
              name: 'mermaids'
            }
          ]
        },
        {
          title: 'Baby Doll Accessories',
          content:
            'Along with adorable dolls, Maisonette finds the best baby doll clothes and accessories for them to wear so your kid can build and change their outfits, working on their fine motor skills. Many dolls can be played with along with a [0] and of course, toy dolls need to get around, so we have prams, doll strollers, baskets, and baby carriers for the baby doll on the go.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/kids/dollhouses-accessories`,
              name: 'doll house'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/play/baby',
      paragraph: [
        {
          title: 'Baby Toys',
          content:
            'Your [0] is full of many exciting developments and milestones, and as kids learn through play, baby toys can give them the best possible start. Since babies are naturally insatiably curious, in the early days, they’ll love playing with [1] like [2] and teethers along with [3] that develop hand-eye coordination. When on dry land, bring on tummy time with [4] and activity mats as they start to work on that core while reaching and grabbing for toys hanging above them. Look for baby toys that use sounds, textures, and bold colors to encourage learning. Stick with Montessori style toys that crinkle, squeak, and shake or toys with attractive surfaces like soft books, sensory balls, and walkers they can push and pull.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/first-birthday`,
              name: 'child’s first year '
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/baby/infant-development`,
              name: 'infant development toys'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/baby/teethers-rattles`,
              name: 'rattles'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/baby/bath-toys`,
              name: 'baby bath toys'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/baby/activity-gyms-playmats`,
              name: 'play gyms'
            }
          ]
        },
        {
          content:
            'Activity cubes and centers can entertain busy babies for hours (maybe minutes that feel like hours).They’re the perfect baby toy to keep in your living room as there are many ways to interact with them, keeping them fresh again and again. Stackers and blocks are classic boy and girl toys that encourage creativity and can grow with them.',
          canonicalUrls: []
        },
        {
          content:
            'Older babies start to toddle around with the support of cute [0], strollers, and [1] which fosters active, creative play and encourages the next milestone: walking.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/baby/push-pull`,
              name: 'baby walkers'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/baby/ride-ons-rockers`,
              name: 'rocking horses'
            }
          ]
        }
      ]
    },
    {
      name: '/shop?product_type=Dresses',
      paragraph: [
        {
          title: 'Maisonette Dress Shop',
          content:
            'Welcome to the Maisonette dress shop, full of chic, wearable [0] that you can actually parent in along with adorable [1] for babies and kids. We make it easy to find the Shop by age, style, color, occasion and price with a curated selection of [2] and a shop with [3].',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/womens/clothing/dresses`,
              name: "womens' dresses"
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/girl-clothing/dresses`,
              name: 'girls dresses'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop?occasion=Dresses+Under+%2450`,
              name: 'dresses under $50'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/whats-new/shops/mommy-me-shop`,
              name: 'matching mommy and me outfits'
            }
          ]
        },
        {
          title: "Womens' Dresses",
          content:
            "We're all about stylish dresses for women that feel good and look great, from school drop-off to work to a date-night-out. Our easy dresses in mini, midi, and maxi lengths make you feel your most confident and most beautiful. With styles from brands like Hill House Home, Pink Chicken, Rhode, and Sea."
        },
        {
          title: "Girls' Dresses",
          content:
            'When it comes to easy one-and-done outfits, dresses for girls are your best bet. Whether she loves sweet florals, classic stripes, plaid, or holiday graphics, we have prints and patterns that she’ll turn to in her closet again and again.'
        },
        {
          content:
            "Our girls' dresses are designed with comfort and style in mind, made from organic cotton, linen, and velvet. You can find the perfect dress for any season. Twirl-ready [0] are also available for special occasions, embellished with sequins, tutu-inspired skirts, or lace. You’ll find a range of styles, from understated smocked styles to old school pinafores, ruffles and wrap styles. For warmer days, our cute sundresses keep her cool and when the weather turns colder, long sleeve dresses keep her cozy.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop?occasion=Party`,
              name: 'party dresses'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/whats-new/shops/mommy-me-shop',
      paragraph: [
        {
          title: 'Mommy and Me Outfits',
          content:
            "Make lasting memories with your mini by exploring our adorable selection of mommy and me outfits. These carefully curated ensembles create memorable moments that you'll cherish forever. Whether you have a special occasion coming up, a vacation, or want to spend quality matchy-matchy time together, our collection of matching outfits is a perfect choice.",
          canonicalUrls: []
        },
        {
          content:
            'Shop our curated collection and discover adorable outfits from brands like Hill House Home, Petite Plume, and Cara Cara to strengthen the bond between you and your mini-me.'
        },
        {
          title: 'Mommy and Me Dresses',
          content:
            'One of our absolute favorite mommy and me outfit choices is coordinating dresses. In coordinating prints, these matching ensembles are perfect for holidays and other memorable events, capturing the essence of motherhood in the most adorable way. Choose from our wide range of options, including sweet pink dresses for a family photoshoot, or opt for a stripe, toile, or eye-catching tropical pattern. Your daughter will love the chance to dress just like Mommy, and you can elevate the experience by accessorizing with matching purses or necklaces.'
        },
        {
          content:
            "But the magic doesn't stop at dresses. Our collection also includes a variety of other mommy and me styles to choose from. Embrace the holiday spirit with [0] and [1] perfect for unwrapping gifts under the tree with your kiddos. Add coordinating headbands or jewelry like a matching charm bracelet. During summer months, we have mommy and me swim for boys and girls.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/family-matching-holiday-clothes`,
              name: 'family matching outfits'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/edits/holiday-pajamas`,
              name: 'family matching pajamas'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/baby/girl-accessories/bows',
      paragraph: [
        {
          title: 'Baby Girl Bows',
          content:
            "Maisonette has a delightful collection of baby bows, headbands, and headwraps. Our [0] bows come in a variety of colors and designs, offering endless styling options. From simple solids to charming floral prints and trend-forward patterns, each bow is carefully crafted. Choose a classic velvet bow for special occasions or a soft organic knit headband to keep stray strands away from her face as she grows. Brands like Bebe Organic, Lali, and Folklore Las Ninas even make bows that match your baby girl's outfit, while Little Poppy Co. and LULULUVs offer sets of bows in a rainbow of hues.",
          canonicalUrls: [
            {
              name: 'baby girl',
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing`
            }
          ]
        },
        {
          title: 'Baby Bows or Headbands?',
          content:
            "We recommend starting with headbands. Even if your little one doesn't have much hair yet, headbands still look adorable and can keep little heads and ears warm. Once she has enough hair for a small ponytail, she's ready for baby hair clips. Our baby girl bows are made from high-quality materials that are gentle on delicate skin. Remember to remove the baby bows during naptime, bedtime, or any time your baby isn't closely supervised and awake. Our baby headbands are made from soft and stretchy materials to ensure a comfortable and secure fit."
        },
        {
          content:
            'Explore our selection of baby [0], including shoes and sunglasses, to pair with your baby bow for a complete look to every outfit, season, and holiday.',
          canonicalUrls: [
            {
              name: 'girl accessories',
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-accessories`
            }
          ]
        }
      ]
    },
    {
      name: '/shop/play/baby/bath-toys',
      paragraph: [
        {
          title: 'Baby Bath Toys',
          content:
            "Around six months, when babies can sit up by themselves and show more interest in [0], is a great time to start introducing bath toys. Babies and toddlers are attracted to bright colors and exploring cause and effect. Bath toys in primary shades that squirt, cups that pour, and other toys that attach to the wall of the bathtub are all fun additional to bathtime. Maisonette's collection of baby bath toys includes creatures like quick-dry sea creatures, safari animals, bugs, and butterflies.",
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/play/baby`,
              name: 'toys'
            }
          ]
        },
        {
          content:
            'For a literary fix babies love turning the pages of bath books in squishy fabrics. Boats that float with coordinating fish or even pirates that babies can push throughout the bath. As babies can start to have more motor skills and grip, bath crayons will entertain them as you suds up with [0] and gentle [1]. Dry off with a [2] because nothing is sweeter than a baby in a hooded towel trimmed in a charming print. We also carry all the essentials for baby’s bath like moisturizer and cleanser along with baby toothbrushes, soft wooden hair brushes, cheek balm for winter months from brands like Noodle & Boo, Palorama, Erbaviva, and Petite Plume.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/bath-body/bath-bubbles`,
              name: 'bubble bath'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/bath-body`,
              name: 'baby shampoo'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/bath-body/towels-robes`,
              name: 'baby towel or robe'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/kids/girl-clothing',
      paragraph: [
        {
          title: 'Shop All Little Girl & Toddler Clothes',
          content:
            'Discover a sweet selection of toddler girl clothes that combine style, comfort, and quality. At Maisonette, we offer everything your little one needs to shine, from playful [0] to [1] perfect for any occasion.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/girl-clothing/dresses`,
              name: 'dresses'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/girl-clothing?product_type=Mixed+Apparel+Set`,
              name: 'mixed outfit sets'
            }
          ]
        },
        {
          title: 'Adorable Dresses and Rompers',
          content: `Our collection of toddler girl clothing features charming dresses and [0] that are perfect for both everyday wear and special moments. Whether you're looking for a twirl-worthy dress or a comfy jumpsuit, you'll find the ideal pieces to keep your little girl looking stylish.`,
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/girl-clothing/rompers`,
              name: 'rompers'
            }
          ]
        },
        {
          title: 'Everyday Wear: Bottoms, Pants, and More',
          content: `From cozy [0] to trendy [1], our toddler girl clothing collection has all the essentials for building the perfect wardrobe. Our bottoms are designed with attention to detail and crafted from high-quality fabric to keep your little one comfortable all day long. Explore a variety of options, including long-sleeve tops and other everyday essentials that suit every season.`,
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/girl-clothing/sweaters`,
              name: 'sweaters'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/girl-clothing/pants`,
              name: 'pants'
            }
          ]
        },
        {
          title: 'Style for All Occasions',
          content: `Maisonette is your one-stop shop for toddler clothes that fit any style. Whether you’re dressing your toddler girl or [0], our clothing collections make getting dressed a breeze. With an array of toddler clothing options and more, you’ll find just what you need to dress your little one in style.`,
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing`,
              name: 'toddler boy'
            }
          ]
        }
      ]
    },
    {
      name: '/shop/kids/boy-clothing',
      paragraph: [
        {
          title: 'Shop All Little Boy and Toddler Clothes',
          content: `Explore our curated collection of toddler boy clothes that combine comfort and style. Whether you're looking for everyday essentials or something special, Maisonette has everything your little guy needs to look his best.`,
          canonicalUrls: []
        },
        {
          title: 'Stylish Boy Clothing',
          content:
            'Our boys’ clothes are designed with your little one in mind, offering a range of shirts, [0], [1], and more. From casual outfits to more polished items, you’ll find just what your toddler needs for every occasion. Keep him cozy in winter with warm [2], or opt for breathable [3] and [4] during warmer days.',
          canonicalUrls: [
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/baby/boy-clothing/pants`,
              name: 'pants'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing/pants?product_type=Jeans`,
              name: 'jeans'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing/sweaters`,
              name: 'sweaters'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing/shorts`,
              name: 'shorts'
            },
            {
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}/shop/kids/boy-clothing/tops?product_type=Shirts&sleeve_length=Short%20Sleeve`,
              name: 'short-sleeve shirts'
            }
          ]
        },
        {
          title: 'Dress Your Little Guy in Versatile Fashion',
          content: `Dress your toddler boy in the latest fashion with our selection of pajamas, outfits, and clothing for every season. Whether you’re searching for winter layers or cool summer stuff, our boy clothes come in a variety of colors and styles to suit his personality. Explore a range of items perfect for both playtime and special occasions.`,
          canonicalUrls: []
        },
        {
          title: 'Complete Outfits for Every Adventure',
          content: `No matter the season, Maisonette offers a complete wardrobe for your little one. From head-to-toe outfits to mix-and-match separates, our toddler boy clothing collection has everything you need to create looks that are as unique as he is.`,
          canonicalUrls: []
        }
      ]
    }
  ];
};

export default ContainerData;
